import React from 'react';
import type { CandidateEngagementDetails } from '@axiom/validation';
import { CandidateEngagementsConst } from '@axiom/const';

import { EngagementsViewStateBannerInterviewingUnaccepted } from './EngagementsViewStateBannerInterviewingUnaccepted';
import { EngagementsViewStateBannerInterviewingClientUnacceptedTalentAccepted } from './EngagementsViewStateBannerInterviewingClientUnacceptedTalentAccepted';
import { EngagementsViewStateBannerInterviewingConfirmed } from './EngagementsViewStateBannerInterviewingConfirmed';

export type EngagementsViewStateBannerPerInterviewProps = {
  engagement: CandidateEngagementDetails;
  interview: CandidateEngagementDetails['interviews'][number];
  name?: string;
};

export const EngagementsViewStateBannerPerInterview = ({
  engagement,
  interview,
  name,
}: EngagementsViewStateBannerPerInterviewProps) => {
  switch (interview.interviewingState) {
    case CandidateEngagementsConst.EngagementStates.InterviewingUnaccepted: {
      return (
        <div data-test={name}>
          <EngagementsViewStateBannerInterviewingUnaccepted
            name="ENGAGEMENTS_VIEW_STATE_BANNER_INTERVIEWING_UNACCEPTED"
            engagement={engagement}
            interview={interview}
          />
        </div>
      );
    }
    case CandidateEngagementsConst.EngagementStates
      .InterviewingClientUnacceptedTalentAccepted: {
      return (
        <div data-test={name}>
          <EngagementsViewStateBannerInterviewingClientUnacceptedTalentAccepted
            name="ENGAGEMENTS_VIEW_STATE_BANNER_INTERVIEWING_CLIENT_UNACCEPTED_TALENT_ACCEPTED"
            interview={interview}
          />
        </div>
      );
    }
    case CandidateEngagementsConst.EngagementStates.InterviewingConfirmed: {
      return (
        <div data-test={name}>
          <EngagementsViewStateBannerInterviewingConfirmed
            name="ENGAGEMENTS_VIEW_STATE_BANNER_INTERVIEWING_CONFIRMED"
            engagement={engagement}
            interview={interview}
          />
        </div>
      );
    }
    default: {
      return null;
    }
  }
};
